<template>
  <el-form ref="form" label-width="12%" v-loading="loading" :model="catPropForm">
    <CatProp v-if="catPropSection" :props="catPropSection.component.props" />
    <div v-else>无</div>
  </el-form>
</template>

<script>
import { getForm } from '@/servers/prod/center/tb';
import { generateSections } from './utils/sections';
import { formatFormData, formatDataForm } from './utils/data';
import CatProp from './components/ComplexItem/CatProp.vue';
import { mapActions, mapGetters } from 'vuex';
import { cloneDeep, isEqual } from 'lodash';

// 批量修改类目的入口
export default {
  components: {
    CatProp,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    categoryIds: Array,
    value: {
      type: Array,
      default: [],
    },
  },
  provide() {
    return {
      tbFormVm: this,
    };
  },
  data() {
    return {
      loading: false,
      catPropSection: null,
      categoryId: '',
      catPropForm: {},
      emitUpdate: true,
      schema: {},
    };
  },
  computed: {
    ...mapGetters(['shops_defaultShopId']),
  },
  watch: {
    categoryIds: {
      handler(v) {
        if (v && v.length) {
          this.categoryId = v[v.length - 1];
          this.getUiData();
        } else {
          this.categoryId = '';
        }
      },
      immediate: true
    },
    catPropForm: {
      handler() {
        this.$emit('change', this.methods_getCatProps());
        this.$nextTick(() => {
          this.validate()
        })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['updateCatePropShopIndex']),
    async getUiData() {
      this.loading = true;
      this.catPropSection = null;
      this.updateCatePropShopIndex('tb');
      const categoryIds = this.categoryIds;
      const res = await getForm({
        shopId: this.shops_defaultShopId('tb'),
        baseItemId: '',
        catId: categoryIds[categoryIds.length - 1],
      });
      this.loading = false;
      if (!res) return;
      this.schema = res;
      this.formHandle()
    },
    methods_setCatProps(v) {
      this.formHandle(v);
    },
    formHandle(v) {
      // 动态表单
      if(!this.schema || !Object.keys(this.schema).length) return;
      const { formData, formSections } = generateSections(this.schema);
      const defaultForm = { ...formData, categoryIds: this.categoryIds };
      const form = formatDataForm({ fieldDescriptorList: v || this.value || [] }, formSections);
      this.catPropForm = { ...defaultForm, ...form };
      this.catPropSection = this._getCatPropSection(formSections.filter(item => item.children.length));
      this.loading = false;
      this.$nextTick(() => {
        this.validate()
      })
    },
    _getCatPropSection(formSections) {
      // 先找基础信息模块
      const baseSections = formSections.find(item => item.title === '基础信息');
      if (!baseSections) return null;

      const catPropSection = baseSections.children.find(item => item.name === 'catProp');
      if (!catPropSection) return null;

      return catPropSection;
    },
    methods_getCatProps() {
      return [
        {
          label: '类目属性',
          name: 'catProp',
          type: 'COMPLEX',
          children: this.catPropSection ? formatFormData(cloneDeep(this.catPropForm), [this.catPropSection]) : [],
        },
      ];
    },
    validate() {
      return new Promise((resolve) => {
        this.$refs.form && this.$refs.form.validate(valid => {
          resolve(valid);
        })
      })
    },
  },
};
</script>

<style>
</style>